import { render, staticRenderFns } from "./BusinessPaymentTableBodySimple.vue?vue&type=template&id=298ec9fe&"
import script from "./BusinessPaymentTableBodySimple.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentTableBodySimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports